// @flow
import React from 'react';

const Footnote = () => <span> &dagger;</span>;

export default Footnote;
